<div class="field-container" [formGroup]="group">
  <mat-checkbox
    class="field-label"
    color="primary"
    [checked]="config?.fieldConfig?.checked"
    [formControlName]="config.name"
    [required]="config.required"
    >{{ config.label }}</mat-checkbox
  >
  <ng-container *ngIf="config.showErrorMessages">
    <ng-container *ngIf="formControl?.errors; else padding">
      <span
        class="error-container"
        [ngStyle]="{ visibility: formControl.touched ? 'inherit' : 'hidden' }"
      >
        {{ formControl?.errors | formError }}
      </span>
    </ng-container>
    <ng-template #padding>
      <span class="error-padding"></span>
    </ng-template>
  </ng-container>
</div>
